import React from 'react'
import classNames from 'classnames'

import './styles.scss'

const TextField = ({ type = 'text', value, placeholder, label, className, name = 'name', onChange, autoComplete }) => {
  const fieldName = `community-text-field-${name}`
  const textFieldClassNames = classNames('community-text-field', className)

  return (
    <div className={textFieldClassNames}>
      {label && (
        <label htmlFor={fieldName}>
          <span>{label}</span>
        </label>
      )}

      <input
        id={fieldName}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        type={type}
        value={value}
        autoComplete={autoComplete}
      />
    </div>
  )
}
export default TextField
